import { createRouter, createWebHistory } from "vue-router";
import Home from "@/views/Home.vue";
import menuModule from "@/store/modules/menu2";
import { ElMessage } from 'element-plus'

const routes = [
  {
    path: "/",
    name: "Home",
    redirect: '/account/login',
    component: Home,
    children: [...menuModule.routes],
  },
  {
    path: "/account/version",
    name: "版本",
    component: () => import("@/views/version"),
  },
  {
    path: "/account/login",
    name: "登录",
    component: () => import("@/views/Login"),
  },
  {
    path: "/forgetPassword",
    name: "忘记密码",
    component: () => import("@/views/forgetPassword/index"),
  },
  {
    path: '/third/risk',
    name: '疫情风险地区',
    component: () => import('@/views/third/risk')
  },
];

const router = createRouter({
  history: createWebHistory("/saas"),
  routes,
});

function generateMenuPerms(perms = []) {
  let menuPerms = {};
  perms.forEach((perm) => {
    menuPerms[perm.perm] = true;
  });
  return menuPerms;
}

function getUsedPath(menu, perms, pathList = []) {
  let menuPerms = {
    ...generateMenuPerms(perms), //生成菜单权限
  };
  menu.map((item) => {
    if (item.path && item.perm && menuPerms[item.perm]) {
      pathList.push(item.path);
    }
    if (item.children && item.children.length) {
      getUsedPath(item.children, perms, pathList);
    }
  });
  return pathList;
}

function getDocumentTitle(menu, to, titleName = "") {
  for (let i = 0; i < menu.length; i++) {
    if (to.path == menu[i].path) {
      titleName = menu[i].name;
      break;
    }
    if (menu[i].children && menu[i].children.length) {
      titleName = getDocumentTitle(menu[i].children, to, titleName);
      if (titleName) {
        break;
      }
    }
  }

  return titleName;
}

function addOperationCount(meta) {
  if (!meta.perm || meta.perm == "personalCenter") {
    return false;
  }
}

router.beforeEach((to, from, next) => {

  // 拦截经营者，当经营者没有经营信息的时候，自动跳转到 个人中心
  let user = window.localStorage.getItem('user')
  if (user) {
    user = JSON.parse(user)
    if (user.userType == 4) {
      let manager = window.localStorage.getItem('manager')
      if (manager) manager = JSON.parse(manager)
      
      if ((manager === '' || manager == null || manager.reviewStatus == 4) && (to.fullPath != '/personal?name=manager' && to.fullPath != '/account/login')) {
        ElMessage.success({
          message: "您没有经营信息，请补全经营信息",
          grouping: true,
        })
        next('/personal?name=manager')
        return
      }
    }
  }

  if (from.fullPath != "/" && from.fullPath != to.fullPath) {
    localStorage.removeItem("curDictPageTab");
    localStorage.removeItem("curUrlPageSize");
    localStorage.removeItem("curUrlPageIndex");
    localStorage.removeItem("curOrderPageTab");
    localStorage.removeItem("curLockPageShowId");
    localStorage.removeItem("curLockPageCodeId");
    localStorage.removeItem("curBellPageShowId");
    localStorage.removeItem("curBellPageCodeId");
    localStorage.removeItem("curManagerPageTab");
    localStorage.removeItem("curAuthlistPageTab");
    localStorage.removeItem("curIsShowAuthorPage");
    localStorage.removeItem("curSysparamsPageTab");
    localStorage.removeItem("curUnauthlistPageTab");
    localStorage.removeItem("curRoomPageisExamine");
    localStorage.removeItem("curRoomPageclassifyKey");
  }

  let perms =
    "perms" in localStorage && localStorage.menu !== ""
      ? JSON.parse(localStorage.menu)
      : [];
  let menu =
    "menu" in localStorage && localStorage.menu !== ""
      ? JSON.parse(localStorage.menu)
      : [];
  // 路由title
  document.title = getDocumentTitle(menu, to);
  if (
    (to.query.area && to.query.area.indexOf("TICKET") > -1) ||
    to.query.TICKET ||
    to.query.ticket
  ) {
    store.dispatch(
      "autoLogin",
      to.query.TICKET || to.query.ticket || to.query.area.slice(12)
    );
    return;
  }
  setTimeout(() => {
    if (!localStorage.login || localStorage.login === "false") {
      if (to.path !== "/account/login" && to.path !== "/forgetPassword") {
        next("/account/login");
      }
    } else if (menu.length === 0) {
      if (to.path !== "/account/login" && to.path !== "/forgetPassword") {
        next("/account/login");
      }
    } else {
      let menuPerms = {
        ...generateMenuPerms(perms), //生成菜单权限
      };
      let menuPath = {
        ...getUsedPath(menu, perms),
      };
      if (to.meta.perm && !menuPerms[to.meta.perm]) {
        //登陆后首页设置
        //return next(menuPath[0]);
        next(menuPath[0])
      }
      if (to.meta.perm && menuPerms[to.meta.perm]) {
        addOperationCount(to.meta); // 操作次数处理
      }
    }
  }, 0);
  next();
});

export default router;
